const ratingReview = document.querySelectorAll('.rating')

ratingReview.forEach(item => {
   const stars = [...item.querySelectorAll('.star')].reverse()
   let ratingNumber = item.dataset.rating
   let radix = Number.parseInt(ratingNumber)

   stars[radix - 1].classList.add('active')
})